export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f69ba9eab46d33ebf504c84365a571b46e4c7ad1e&name=fetchTypeahead!'